module.exports = __webpack_public_path__ + "assets/images/hold.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/hold.png
// module id = 402
// module chunks = 1